import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "@funded-here-interface/common/src/dashboard/components/ErrorBoundry";
import { setAppType } from "@funded-here-interface/common/src/constant/appType";

setAppType("admin");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
